import { os } from '@utils/device-utils';
import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';



const RiskSection: FC = () => {
	const { width } = useResizeObserver();
	const { transData, t, list } = useTranslation('prices.risk')

	const ListRenderTitle = t('home.safeguard.list').map((item: { img: string | undefined; title: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; content: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined }, index: React.Key | undefined) => {
		return (
			<div
				key={index}
				className={styles['title-item']}
			>
				<div className={styles['img-wrap']}>
					<img loading='lazy' src={item.img} alt="" />
				</div>
				<div className={styles['text-wrap']}>
					<h4>{item.title}</h4>
					<p>{item.content}</p>
				</div>
			</div>
		)
	})

	return (
		<section className={styles['ac-risk']}>
			<div className={styles['ac-risk-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={styles['ac-risk-content']}>
					<img src="https://web-data.zmlearn.com/image/jpx8ke1eUACTXzgQk96j4U/img_P3%402x.png" alt="" loading='lazy' />
					{/* {(width >= 768 && width < 1192) && <>
						<img src="https://web-data.zmlearn.com/image/4gQP81m5AHMa6Dppr15LbF/img_P5%402x.png" alt="" loading='lazy' />
						<img src="https://web-data.zmlearn.com/image/nTonBEesrwYrDMoKLvZueZ/img_P5%402x%20(1).png" alt="" loading='lazy' />
					</>} */}
					<div className={classnames(styles['ac-risk-title'], 'ac-risk-title')}
					>{ListRenderTitle}</div>
				</div>
			</div>
		</section >
	);
}

export default RiskSection
